export async function setLanguage(dispatch, payload) {
  dispatch({ type: "SET_LANGUAGE", payload });
  localStorage.setItem("lng", payload.language);
}
